/**
 * FRONT-DESK-MONEY-AND-DOCUMENTS-V1 (PR2) -- PrintDoor: THE ONE print door.
 *
 * THE DEFECT IT CLOSES (FRONT-DESK-REPLACEMENT-DEPTH-V1, LEAVES-2 / L-17):
 * the receptionist "goes to the billing page (or elsewhere) to print at all,
 * because the record she is looking at has no print door" -- measured at
 * head as 0 occurrences of "print" in the Patient 360 (1908 lines) and 0 in
 * the Money desk (2316 lines). Printing required arming an appointment on
 * `/dashboard/billing-entry`.
 *
 * THIS IS A DOOR, NOT A PRINT SYSTEM. It renders no document, owns no
 * layout, fetches nothing and writes nothing: it is the registered AcButton
 * shape plus ONE testid convention, so a door reads the same wherever the
 * desk meets one. What it OPENS is the existing print rail
 * (`dashboard/ui/PrintSheet.tsx`) and, where the surface has one, an
 * existing member of the print family (BillPrintView / ReceiptPrintView).
 * No second print system is introduced by this component or its callers.
 *
 * THE PRINT-NEVER-REPEATS-MONEY LAW (R-G / FS-29) reaches the door too: a
 * door may only ever open presentation over an ALREADY-COMMITTED record, so
 * no caller may mint, finalize or amend anything on the way through one.
 */

import AcButton from './AcButton';

export interface PrintDoorProps {
  /** What the door opens, in the operator's words (e.g. "Print bill"). */
  readonly label: string;
  readonly onOpen: () => void;
  /** Disabled while the caller is loading the already-committed record. */
  readonly disabled?: boolean;
  readonly size?: 'sm' | 'md';
  readonly testId?: string;
}

export default function PrintDoor({
  label,
  onOpen,
  disabled,
  size = 'sm',
  testId,
}: PrintDoorProps): JSX.Element {
  return (
    <AcButton
      variant="secondary"
      size={size}
      onClick={onOpen}
      disabled={disabled === true}
      data-testid={testId}
    >
      {label}
    </AcButton>
  );
}
